module.exports = __webpack_public_path__ + "img/title1.0b0b832b.png";